import { render, staticRenderFns } from "./AdminTickets.vue?vue&type=template&id=88d4c32a&scoped=true"
import script from "./AdminTickets.vue?vue&type=script&lang=js"
export * from "./AdminTickets.vue?vue&type=script&lang=js"
import style0 from "./AdminTickets.vue?vue&type=style&index=0&id=88d4c32a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d4c32a",
  null
  
)

export default component.exports